import { render, staticRenderFns } from "./AmazonImportTabsModal.vue?vue&type=template&id=b06163ee&scoped=true"
import script from "./AmazonImportTabsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AmazonImportTabsModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AmazonImportTabsModal.vue?vue&type=style&index=0&id=b06163ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06163ee",
  null
  
)

export default component.exports